import * as React from 'react'
import { NewsItem_NewsItemEdgeFragment } from 'generated/graphql'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'
import ScreenNewsItemModalDesktop from './ScreenNewsItemModal.desktop'
import ScreenNewsItemModalMobile from './ScreenNewsItemModal.mobile'

interface IFScreenNewsItemModalProps extends IFModalProps {
  data: Omit<NewsItem_NewsItemEdgeFragment, '__typename' | 'cursor'>
}

const ScreenNewsItemModal: React.FC<IFScreenNewsItemModalProps> = ({
  data,
  onClose,
  ...props
}) => {
  return (
    <Modal onClose={onClose} {...props}>
      <ScreenNewsItemModalDesktop data={data} onClose={onClose} />
      <ScreenNewsItemModalMobile data={data} onClose={onClose} />
    </Modal>
  )
}

export default ScreenNewsItemModal
